import { ReactNode } from "react";

type CardProps = {
  children: ReactNode;
  className?: string;
  padding?: "none" | "sm" | "md" | "lg";
  /** Opcional: hace la card clickable (cursor + handler). */
  onClick?: () => void;
};

// White card with subtle shadow — the standard surface for content blocks
// in the logistics platform. Padding tokens keep spacing consistent across
// the app instead of having every page pick its own px-4 py-3.
export function Card({ children, className = "", padding = "md", onClick }: CardProps) {
  const padCls =
    padding === "none"
      ? ""
      : padding === "sm"
        ? "p-3"
        : padding === "lg"
          ? "p-6"
          : "p-4";
  return (
    <div
      onClick={onClick}
      className={`bg-card border border-border rounded-lg shadow-card ${padCls} ${className}`}
    >
      {children}
    </div>
  );
}

// CardHeader is an opinionated row for the top of a Card. Title left,
// optional right-aligned actions slot.
export function CardHeader({
  title,
  subtitle,
  actions,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="flex items-start justify-between mb-3 pb-3 border-b border-border">
      <div>
        <h3 className="text-sm font-semibold text-ink">{title}</h3>
        {subtitle && <p className="text-xs text-sub mt-0.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
